import { AfterViewInit, Component } from "@angular/core";
import { Location } from "@angular/common";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { Observable } from "rxjs";

import { BASE_CONSTANTS, OUTSIDE_URLS } from "@tci/common";
import { NgWsDiscoveryService } from "../ng-shared/ng-services/ng-ws-discovery.service";

@Component({
    selector: "empty",
    templateUrl: "./ng-user-exceptions.component.html"
})
export class NgUserExceptionsComponent implements AfterViewInit {

    private redirectionTimeout = 5000; // default value in milliseconds
    private timeLapse = 0; // milliseconds
    private messageTitleKeys = {
        [BASE_CONSTANTS.UNREGISTERED_ERROR]: "USER_EXCEPTIONS.TA_REGISTER_ERROR",
        [BASE_CONSTANTS.DISABLED_ERROR]: "USER_EXCEPTIONS.DISABLED_USER_ERROR",
        [BASE_CONSTANTS.EULA_ERROR]: "USER_EXCEPTIONS.EULA_ERROR"
    };
    private messageKeys = {
        [BASE_CONSTANTS.UNREGISTERED_ERROR]: "USER_EXCEPTIONS.TA_REGISTER_SECONDARY_ERROR",
        [BASE_CONSTANTS.DISABLED_ERROR]: "USER_EXCEPTIONS.DISABLED_USER_SECONDARY_ERROR",
        [BASE_CONSTANTS.EULA_ERROR]: "USER_EXCEPTIONS.EULA_SECONDARY_ERROR"
    };
    private urlsToGo = {
        [BASE_CONSTANTS.UNREGISTERED_ERROR]: OUTSIDE_URLS.TIBCO_CLOUD_PRICING,
        [BASE_CONSTANTS.DISABLED_ERROR]: OUTSIDE_URLS.TIBCO_CLOUD,
        [BASE_CONSTANTS.EULA_ERROR]: OUTSIDE_URLS.TIBCO_CLOUD
    };
    private messageTitle = "";
    private message = "";
    private urlToGo = "";
    private round = Math.round;

    constructor(
        private location: Location,
        private wsDiscovery: NgWsDiscoveryService,
        private router: Router,
        private translate: TranslateService
    ) {
        const path = this
            .location
            .path(false)
            .replace(/^\//, "");

        this.urlToGo = this.urlsToGo[path];
        this
            .translate
            .get(this.messageTitleKeys[path])
            .subscribe(
                messageTitle => {
                    this.messageTitle = messageTitle;
                },
                error => {
                    console.log("Error getting the message title: ", error);
                }
            );
        this
            .translate
            .get(this.messageKeys[path])
            .subscribe(
                message => {
                    this.message = message;
                },
                error => {
                    console.log("Error getting the message: ", error);
                }
            );
        this
            .wsDiscovery
            .getRedirectionTime()
            .subscribe(
                (redirectionTime: number) => {
                    this.redirectionTimeout = redirectionTime * 1000;
                }
            );
    }

    ngAfterViewInit(): void {
        this.countDown();
    }

    private countDown() {
        Observable
            .interval(1000)
            .subscribe(
                () => {
                    if (this.timeLapse < this.redirectionTimeout) {
                        this.timeLapse += 1000;
                    } else {
                        this.goToUrl();
                    }
                }
            );
    }

    private goToUrl(): void {
        (<any>window).location.href = this.urlToGo;
    }
}
